import { Component, inject, Input } from '@angular/core';
import { BasketOrder } from '../../../../models/basket-order.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipUtil } from '../../util/tooltip-util';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgIf } from '@angular/common';
import { LIST_BASKET_ORDER_STATUS } from '../../../../models/basket-order-status.model';
import { LIST_PAYMENT_METHOD } from '../../../../models/payment-method.model';

@Component({
  selector: 'jhi-bary-invoice-status',
  templateUrl: './bary-invoice-status.component.html',
  standalone: true,
  imports: [MDBBootstrapModulesPro, NgIf, TranslateModule],
})
export class BaryInvoiceStatusComponent {
  readonly #translateService = inject(TranslateService);

  @Input() public basketOrder!: BasketOrder;

  public LIST_BASKET_ORDER_STATUS = LIST_BASKET_ORDER_STATUS;
  public LIST_PAYMENT_METHOD = LIST_PAYMENT_METHOD;

  public hasToBePaid = (): boolean =>
    LIST_BASKET_ORDER_STATUS.BILLED.code === this.basketOrder.status && LIST_PAYMENT_METHOD.INIT_TRANSFERT_DEFERRED.code === this.basketOrder.paymentMethod;

  public getLateTooltipMessage = (): string => this.#translateService.instant('TOOLTIP_MESSAGE.INFORMATION_ON_DUNNING_EMAILS', TooltipUtil.getLateTooltipMessage(this.basketOrder));
}
